import { PopperProps } from '@mui/material/Popper'
import cn from 'classnames'
import Tooltip from 'ext-ui/components/Tooltip/Tooltip'
import { styles } from 'ext-ui/components/TooltipIcon/TooltipIcon.style'
import React, { ReactElement, useState } from 'react'
import SvgTooltip from 'src/components/Svgs/SvgTooltip'
import SvgTooltipHoverColored from 'src/components/Tooltip/SvgTooltipHoverColored'

export type TooltipIconProps = {
  icon?: React.ReactNode
  iconTestId?: string
  iconHover?: React.ReactNode
  arrow?: boolean
  variant?: 'default' | 'spotlight'
  size?: 'medium'
  placement?: PopperProps['placement']
  children: React.ReactNode
  className?: string
}

function TooltipIcon(props: TooltipIconProps): ReactElement {
  const [tooltipOpen, setTooltipOpen] = useState(false)
  const {
    icon = <SvgTooltip />,
    iconTestId,
    iconHover = props.icon ?? <SvgTooltipHoverColored />,
    variant = 'default',
    size = 'medium',
    placement = 'top',
    arrow = true,
    className,
    children,
  } = props

  return (
    <div css={styles} className={cn(className, size)}>
      <Tooltip
        tooltipContent={children}
        arrow={arrow}
        variant={variant}
        placement={placement}
        onOpen={(): void => {
          setTooltipOpen(true)
        }}
        onClose={(): void => {
          setTooltipOpen(false)
        }}
      >
        <div className={'icon-wrapper'} data-testid={iconTestId}>
          {!tooltipOpen && icon}
          {tooltipOpen && iconHover}
        </div>
      </Tooltip>
    </div>
  )
}

export default TooltipIcon
